// extracted by mini-css-extract-plugin
module.exports = {"redaction":"_9e1425b4d3--redaction--WJ2oV","redaction__text":"_9e1425b4d3--redaction__text--FczEZ","redaction__link":"_9e1425b4d3--redaction__link--Csypg"};